export { default } from './FormHistoricalFigure.vue'
